export const ROUTE_PATHS = {
    HOME: "/",
    THANKYOU: "/thank-you",
    LOGIN: "/inicio-sesion",
    REGISTER: "/registro",
    POLICY: "/politica-privacidad",
    TERMS: "/terminos-uso",
    VISITREGISTER: "/registro-visita",
    VISIT: "/mis-visitas",
    VISITORQR: "/visita/:guid",
    SUBSCRIPTION: "/suscripcion",
    CONTACTUS: "/contacto",
    BIZCODECONTACTUS: "/bizcode-contactus",
    BIZCODEOFFICE: "/bizcode-office",
    FAQS: "/bizcode-faqs",
    ANNOUNCEMENTS:  "/anuncios",
    BIZCODEHOME: "/bizcode-home",
    PAYMENTS: "/pagos",
    FEATURES: "/features",
    NEWPAYMENT: "/pagos/nuevo",
    ACCOUNTING: "/contabilidad-general",
    AMENITIES: "/amenidades",
    DOCUMENTS: "/documentos",
    INICIOSESION: "/inicio-sesion",
    NEWAMENITYPAGE: "/nueva-amenidad",
    AMENITYSELECTION: "/amenidades/seleccion",
    ADMINPAYMENTPAGE: "/admin/pagos",
    ADMINPAYMENTPAGEBYID: "/admin/pagos/:houseOwnerId",
    ADMINDASHBOARD: "/admin",
    ADMINOWNERSPAGE: "/admin/propietarios",
    ADMINAMENITIESPAGE: "/admin/amenidades",
    ADMINACCOUNTINGPAGE: "/admin/contabilidad-general",
    ADMINANNOUNCEMENTSPAGE: "/admin/anuncios",
    ADMINCATALOGSPAGE: "/admin/catalogos",
    ACCESSDOORPAGE: "/access-door",
    INVITATION_ACTIVATION: "/invitacion/:invitationGuid",
}